import React, { useState,useEffect } from 'react';
import {
  Card,
  Avatar,
  Row,
  Col,
  Typography,
  Space,
  Badge,
  Tabs,
  Switch,
  Image,
  Button,
  message,
  Spin
} from 'antd';
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  TeamOutlined,
  BankOutlined,
  IdcardOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import Cookies from 'js-cookie';


const { Title, Text } = Typography;
const { TabPane } = Tabs;

const ProfilePage = () => {
  const [profileData,setProfileData] = useState([]);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isImageModified, setIsImageModified] = useState(false);
  const [loading, setLoading] = useState(false);

   const userid = Cookies.get('userId')

  useEffect(() => {
    const fetchUserData = async () => {


      try {

        const apiService = new ApiService(
          `${BASE_URL}/fetch_single_record/User/${userid}`,
          { 'Content-Type': 'application/json' },
          'GET'

        );
        const res = await apiService.makeCall();

        setProfileData(res);



      }
      catch (error) {

      }


    }

    fetchUserData();
  }, [userid]);

  // Handle image upload
  const handleImageUpload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result; // Keep the full data URL
          setUploadedImage(base64String);
          setIsImageModified(true);
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  // Handle remove image
  const handleRemoveImage = () => {
    setUploadedImage(null);
    setIsImageModified(true);
  };

  // Handle save image
  const handleSaveImage = async () => {
    try {
      setLoading(true);
      
      const bodyData = {
        image: uploadedImage ? uploadedImage.split(',')[1] : null // Extract base64 without data URL prefix
      };

      const body = {
        object_name: "User",
        data: {
          _id: profileData._id,
          ...bodyData
        }
      };

      const apiService = new ApiService(
        `${BASE_URL}/insert_or_update_records`,
        { 'Content-Type': 'application/json' },
        'POST',
        body
      );
      
      await apiService.makeCall();
      
      setIsImageModified(false);
      setUploadedImage(null);

      message.success('Image updated successfully');
      
      // Refresh profile data
      const apiServiceRefresh = new ApiService(
        `${BASE_URL}/fetch_single_record/User/${userid}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const res = await apiServiceRefresh.makeCall();
      setProfileData(res);
      // Update cookie with latest image filename from response (or remove if none)
      if (res && res.image) {
        Cookies.set('image', res.image, { expires: 365 });
      } 
      
      
    } catch (error) {
      message.error('Failed to update image');
      console.error('Error updating image:', error);
    } finally {
      setLoading(false);
    }
  };

  // Handle cancel image
  const handleCancelImage = () => {
    setUploadedImage(null);
    setIsImageModified(false);
  };

  // InfoItem for personal details
  const PersonalInfoItem = ({ icon, label, value, span = 12 }) => (
    <Col span={span}>
      <div
        style={{
          marginBottom: '12px',
          padding: '3px 6px',
          borderRadius: '5px',
          display: 'inline-block',
          width: '100%',
        }}
      >
        <Space>
          {icon}
          <Text strong style={{ color: '#666', fontSize: '14px' }}>{label}</Text>
        </Space>
        <div
          style={{
            marginTop: '3px',
            marginLeft: '19px',
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #e0e0e0',
            minHeight: '20px',
            paddingBottom: '2px',
          }}
        >
          <Text style={{ fontSize: '14px' }}>{value || ''}</Text>
        </div>
      </div>
    </Col>
  );

  // InfoItem for professional details
  const ProfessionalInfoItem = ({ icon, label, value, span = 12 }) => (

    
    <Col span={span}>
      <div
        style={{
          marginBottom: '12px',
          padding: '3px 6px',
          borderRadius: '5px',
        }}
      >
        <Space>
          {icon}
          <Text strong style={{ color: '#666', fontSize: '14px' }}>{label}</Text>
        </Space>
        <div
          style={{
            marginTop: '3px',
            marginLeft: '19px',
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #e0e0e0',
            minHeight: '20px',
            paddingBottom: '2px',
          }}
        >
          <Text style={{ fontSize: '14px' }}>{value || ''}</Text>
        </div>
      </div>
    </Col>
  );



  return (
    <div
      style={{
        padding: '24px',
        maxWidth: '1400px',
        margin: '0 auto',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Spin spinning={loading} tip="Updating image...">
        {/* Header Section */}
        <Card
          style={{
            marginBottom: '24px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Row align="middle" justify="space-between">
            <Col>
              <Row align="middle" gutter={24}>
                <Col>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                    <Badge.Ribbon
                      text={
                        profileData.accountStatus ||
                        (profileData.is_active ? 'Active' : 'Inactive')
                      }
                      color={
                        profileData.accountStatus === 'Active' ||
                        profileData.is_active
                          ? 'green'
                          : 'red'
                      }
                    >
                      {uploadedImage ? (
                        <img
                          src={uploadedImage}
                          alt="Profile Preview"
                          style={{
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '3px solid #f0f0f0',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          }}
                        />
                      ) : profileData?.image ? (
                        <Image
                          width={100}
                          height={100}
                          style={{
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: '3px solid #f0f0f0',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            background: '#ccc',
                          }}
                          src={`${BASE_URL}/ImageUpload/${profileData?.org_id}/${profileData?.image}.png`}

                          alt="Profile"
                        />
                      ) : (
                        <Avatar
                          size={64}
                          style={{
                            border: '2px solid #f0f0f0',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                            background: '#ccc',
                            color: '#fff',
                            fontSize: 14,
                          }}
                        >
                          {(profileData.first_name || profileData.Name)
                            ? (
                                (profileData.first_name ||
                                  profileData.Name.split(' ')[0])[0] +
                                (profileData.last_name ||
                                  profileData.Name.split(' ')[1] ||
                                  '')[0]
                              ).toUpperCase()
                            : null}
                        </Avatar>
                      )}
                    </Badge.Ribbon>
                    {/* Image Upload/Remove Buttons */}
                    <Space direction="vertical" style={{ width: '100%' }}>
                      <Space>
                        {(uploadedImage || profileData?.image) && (
                          <Button
                            onClick={handleImageUpload}
                            size="small"
                          >
                            Change
                          </Button>
                        )}
                        {!uploadedImage && profileData?.image && (
                          <Button
                            danger
                            onClick={handleRemoveImage}
                            size="small"
                          >
                            Remove
                          </Button>
                        )}
                        {!uploadedImage && !profileData?.image && (
                          <Button
                            onClick={handleImageUpload}
                            size="small"
                          >
                            Upload Image
                          </Button>
                        )}
                      </Space>

                      {/* Inline Save/Cancel beneath the image only */}
                      {isImageModified && (
                        <div style={{ marginTop: 8, display: 'flex', justifyContent: 'center', gap: 8 }}>
                          <Button onClick={handleCancelImage}>
                            Cancel
                          </Button>
                          <Button type="primary" onClick={handleSaveImage} loading={loading}>
                            Save
                          </Button>
                        </div>
                      )}
                    </Space>
                  </div>
                </Col>
                <Col>
                  <Title
                    level={5}
                    style={{
                      margin: '0 0 8px 0',
                      color: '#262626',
                      fontSize: '14px',
                    }}
                  >
                    {profileData.first_name ||
                      (profileData.Name && profileData.Name.split(' ')[0])}{' '}
                    {profileData.last_name ||
                      (profileData.Name && profileData.Name.split(' ')[1])}
                  </Title>
                  <Text style={{ fontSize: '14px', color: '#666' }}>
                    {profileData.division}{' '}
                    {profileData.department
                      ? `• ${profileData.department}`
                      : ''}
                  </Text>
                  <br />
                  <Text style={{ fontSize: '14px', color: '#999' }}>
                  {profileData.EmployeeCode || ''}
                </Text>
                <br />
                {/* <Space style={{ marginTop: '4px' }}>
                  <Badge
                    status={profileData.is_active ? 'success' : 'default'}
                  />
                  <Text style={{ fontSize: '14px', color: '#999' }}>
                    Last login {profileData.lastLogin || ''}
                  </Text>
                </Space> */}
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>

      {/* Main Content */}
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={16}>
          <Card
            title={<span style={{ fontSize: '14px' }}>User Information</span>}
            style={{ marginBottom: '12px' }}
          >
            <Tabs defaultActiveKey="1" >
              {/* Personal Details */}
              <TabPane tab="Personal Details" key="1">
                <Row gutter={[24, 16]}>
                  <PersonalInfoItem
                    icon={<UserOutlined />}
                    label="First Name"
                    value={
                      profileData.first_name ||
                      (profileData.Name && profileData.Name.split(' ')[0])
                    }
                  />
                  <PersonalInfoItem
                    icon={<UserOutlined />}
                    label="Last Name"
                    value={
                      profileData.last_name ||
                      (profileData.Name && profileData.Name.split(' ')[1])
                    }
                  />
                  <PersonalInfoItem
                    icon={<MailOutlined />}
                    label="Email Address"
                    value={profileData?.email}
                  />
                  <PersonalInfoItem
                    icon={<PhoneOutlined />}
                    label="Phone Number"
                    value={profileData.phone}
                  />
                  <PersonalInfoItem
                    icon={<PhoneOutlined />}
                    label="Mobile Number"
                    value={profileData.mobile}
                  />
                  <PersonalInfoItem
                    icon={<CalendarOutlined />}
                    label="Date of Birth"
                    value={
                      profileData.DateOfBirth
                        ? dayjs(profileData.DateOfBirth).format(
                            'MMMM DD, YYYY'
                          )
                        : ''
                    }
                  />
                  <PersonalInfoItem
                    icon={<EnvironmentOutlined />}
                    label="Address"
                    value={
                      profileData.Address
                        ? [
                            profileData.Address.street,
                            profileData.Address.city,
                            profileData.Address.state,
                            profileData.Address.country,
                            profileData.Address.postal_code,
                          ].filter(Boolean).join(', ')
                        : ''
                    }
                    span={24}
                  />
                  <PersonalInfoItem
                    icon={<UserOutlined />}
                    label="Gender"
                    value={profileData.Gender}
                  />
                  <PersonalInfoItem
                    icon={<UserOutlined />}
                    label="Marital Status"
                    value={profileData.MaritalStatus}
                  />
                </Row>
              </TabPane>

              {/* Professional Details */}
              <TabPane tab="Professional Details" key="2">
                <Row gutter={[24, 16]}>
                  <ProfessionalInfoItem
                    icon={<IdcardOutlined />}
                    label="Employee Code"
                    value={profileData.EmployeeCode}
                  />
                  <ProfessionalInfoItem
                    icon={<BankOutlined />}
                    label="Department"
                    value={profileData.department}
                  />
                  <ProfessionalInfoItem
                    icon={<UserOutlined />}
                    label="Division"
                    value={profileData.division}
                  />
                  <ProfessionalInfoItem
                    icon={<ClockCircleOutlined />}
                    label="Employment Type"
                    value={profileData.EmploymentType}
                  />
                  <ProfessionalInfoItem
                    icon={<CalendarOutlined />}
                    label="Date Of Joining"
                    value={
                      profileData.DateOfJoining
                        ? dayjs(profileData.DateOfJoining).format(
                            'MMMM DD, YYYY'
                          )
                        : ''
                    }
                  />
                  <ProfessionalInfoItem
                    icon={<TeamOutlined />}
                    label="Reporting Manager"
                    value={profileData.reportingManager?.Name}
                  />
                  <ProfessionalInfoItem
                    icon={<MailOutlined />}
                    label="Manager Email"
                    value={profileData.managerEmail}
                  />
                </Row>
              </TabPane>
            </Tabs>
          </Card>
        </Col>

        {/* Right Column */}
        <Col xs={24} lg={8}>
          {/* System Information */}
          <Card
            title={<span style={{ fontSize: '14px' }}>System Information</span>}
            style={{ marginBottom: '24px' }}
          >
            <Row gutter={[24, 8]}>
              <Col span={12}>
                <Text strong>User Name</Text>
                <br />
                <Text code>{profileData.username || ''}</Text>
              </Col>
              <Col span={12}>
                <Text strong>User Role</Text>
                <br />
                <Text>{profileData.userRole || ''}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Created By</Text>
                <br />
                <Text>{profileData.CreatedBy?.Name || ''}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Last Modified By</Text>
                <br />
                <Text>{profileData.LastModifiedBy?.Name || ''}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Last Login</Text>
                <br />
                <Text>{profileData.lastLogin || ''}</Text>
              </Col>
            </Row>
          </Card>

          {/* Preferences */}
          <Card
            title={<span style={{ fontSize: '14px' }}>Preferences</span>}
          >
            <Row gutter={[24, 8]}>
              <Col span={12}>
                <Text strong>Timezone</Text>
                <br />
                <Text>{profileData.timezone || ''}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Language</Text>
                <br />
                <Text>{profileData.language || ''}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Currency</Text>
                <br />
                <Text>{profileData.currency || ''}</Text>
              </Col>
              <Col span={12}>
                <Text strong>Active Status</Text>
                <br />
                <Switch checked={profileData.is_active} size="small" disabled />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      </Spin>
    </div>
  );
};

export default ProfilePage;